import {
  Component,
  inject,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../core/services/auth.service';
import { LoggingService } from '../../core/services/logging.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  readonly authService = inject(AuthService);
  private readonly logger = inject(LoggingService);
  private readonly router = inject(Router);
  private readonly destroy$ = new Subject<void>();

  loading = false;
  errorMessage = '';

  ngOnInit(): void {
    // Subscribe to authentication errors from BFF
    this.authService.authError$
      .pipe(takeUntil(this.destroy$))
      .subscribe(error => {
        this.errorMessage = error ?? '';
        if (error) {
          this.logger.info('Displaying auth error', { error });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Redirect to BFF login page.
   * BFF handles OAuth flow with Entra ID and redirects back.
   */
  onSSOLogin(): void {
    this.logger.info('Redirecting to BFF for SSO login');
    this.loading = true;
    this.errorMessage = '';

    // Clear any previous auth errors
    this.authService.clearAuthError();

    // Redirect to BFF - page will navigate away
    this.authService.loginWithSSO();
  }
}
